import React from 'react';
import { theme } from '../styles/theme';

function EmptyState({ text }) {
  return <p style={styles.text}>{text}</p>;
}

const styles = {
  text: {
    color: theme.colors.textSecondary,
    fontSize: '16px',
    margin: '30px 0',
    textAlign: 'center',
  },
};

export default EmptyState;
